import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import { default as PropTypes, default as propTypes } from 'prop-types';
import React, { useState } from 'react';

export default function UrlFormatter(props) {
  const [values, setValues] = useState({ ...props.defeault });
  const ALL = 'Tous';
  const dates = props.dates?.map((date) => (
    <FieldWrapper
      style={{ width: '10rem', marginRight: '10px' }}
      key={date.label}
      className="col-md-2 customCol"
    >
      <Label
        id={date.label}
        style={{
          color: '#a5a5a5',
          fontWeight: 'bold',
        }}
      >
        {date.label}
      </Label>
      <DatePicker
        value={values[date.key]}
        onChange={(e) => {
          setValues({
            ...values,
            [date.key]: e.value,
          });
        }}
      />
    </FieldWrapper>
  ));

  const inputs = props.inputs?.map((input) => (
    <FieldWrapper
      style={{ width: '10rem', marginLeft: '10px' }}
      key={input.label}
      className="col-md-1 customCol"
    >
      <Label
        id={input.label}
        style={{
          color: '#a5a5a5',
          fontWeight: 'bold',
        }}
      >
        {input.label}
      </Label>
      <Input
        className="customInput"
        value={values[input.key]}
        onChange={(e) => {
          setValues({
            ...values,
            [input.key]: `${e.value}`,
          });
        }}
      />
    </FieldWrapper>
  ));

  const dropDowns = props.dropDowns?.map((input) => {
    let inputCopy = JSON.stringify(input);
    inputCopy = JSON.parse(inputCopy);
    if (
      inputCopy.values !== undefined &&
      !inputCopy.values.some((item) => item[inputCopy.key] === ALL)
    )
      inputCopy.values.push({ [inputCopy.key]: ALL });
    return (
      <FieldWrapper
        style={{ marginLeft: '10px' }}
        key={inputCopy.label}
        className="col-md-2 customCol"
      >
        <Label
          id={inputCopy.label}
          style={{
            color: '#a5a5a5',
            fontWeight: 'bold',
          }}
        >
          {inputCopy.label}
        </Label>
        <DropDownList
          value={values[inputCopy.key]}
          data={inputCopy.values?.map((item) => item[inputCopy.key])}
          onChange={(e) => {
            setValues({
              ...values,
              [inputCopy.key]: `${e.value}`,
            });
          }}
        />
      </FieldWrapper>
    );
  });

  const updateUrl = () => {
    let query = '';
    for (let param in values)
      if (values[param] !== '' && values[param] !== null)
        if (values[param] instanceof Date)
          query += `${param}=${values[param].getDate()}/0${values[param].getMonth() + 1
            }/${values[param].getFullYear()}&`;
        else if (values[param] === ALL) continue;
        else query += `${param}=${values[param]}&`;
    props.updateQuery(query);
  };

  const todayDate = () => {
    let today = new Date();
    let month = new Date();

    month.setMonth(today.getMonth() + 1);

    setValues({
      ...values,
      ['dtDeb']: today,
      ['dtFin']: month,
    });
  };

  return (
    <Card
      type="none"
      canCollapse={false}
      style={{
        backgroundColor: 'white',
        paddingTop: '0',
      }}
    >
      <div className="inline">
        <Header title={props.title}></Header>
        <div className="me-auto"></div>
        {props.canAdd && (
          <Button className="blueButton" onClick={props.create}>
            {props.titleButton}
          </Button>
        )}
      </div>
      <Body>
        <Form
          render={(formRenderProps) => (
            <FormElement>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexWrap: 'wrap',
                }}
              >
                {dates}
                {inputs}
                {dropDowns}
              </div>
              <div className="k-form-buttons">
                <Button
                  icon="search"
                  style={{
                    width: '250px',
                  }}
                  onClick={updateUrl}
                  className="blueButton"
                >
                  Rechercher
                </Button>
                {props.today && (
                  <Button
                    style={{
                      width: '150px',
                    }}
                    onClick={todayDate}
                    className="whiteButton"
                  >
                    {`Aujourd'hui`}
                  </Button>
                )}
                <Button
                  className="whiteButton"
                  style={{
                    height: '34px',
                    width: '150px',
                  }}
                  onClick={() => {
                    formRenderProps.onFormReset();
                    setValues({ ...props.defeault });
                  }}
                >
                  Réinitialiser
                </Button>
              </div>
            </FormElement>
          )}
        />
      </Body>
    </Card>
  );
}

UrlFormatter.propTypes = {
  create: PropTypes.func,
  dates: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  defeault: PropTypes.object,
  dropDowns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      values: PropTypes.array,
    })
  ),
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  title: PropTypes.string,
  titleButton: PropTypes.string,
  updateQuery: PropTypes.func,
  canAdd: PropTypes.bool,
  today: propTypes.bool,
};
